<template>
  <div
    v-blokkli-editable:field_title
    :class="{ container: !parentType }"
    class="!mt-size-6"
  >
    <ClientOnly>
      <Postcard
        :campaign-key="props.campaign?.campaignKey"
        :campaign-text="props.campaign?.campaignText"
        :qr-link="props.campaign?.qrLink"
        :stamp-image-url="props.campaign?.stampImageUrl"
        :webform-id="props.campaign?.webformId"
        :button-text="props.buttonText"
        :designs="postcardDesigns"
      />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import Postcard from '~~/layers/postcard/app/components/Postcard/index.vue'
import type { PostcardDesignOption } from '~~/layers/postcard/app/types'
import { mapParagraphPostcardDesigns } from '~~/layers/postcard/app/utils/mapParagraphPostcardDesigns'

// Local props type: Vue cannot extract runtime props from imported GraphQL
// fragment types, so declare fields explicitly.
const props = defineProps<{
  campaign?: {
    campaignKey?: string | null
    campaignText?: string | null
    qrLink?: string | null
    stampImageUrl?: string | null
    webformId?: string | null
    designs?: Array<{
      id?: string | null
      text?: string | null
      imageUrl?: string | null
      imageAlt?: string | null
      previewImageUrl?: string | null
      previewImageAlt?: string | null
    } | null> | null
  } | null
  buttonText?: string | null
}>()

const { parentType } = defineBlokkli({
  bundle: 'postcard',
  editor: {
    icon: 'bk_mdi_contact_mail',
  },
})

const postcardDesigns: PostcardDesignOption[] = mapParagraphPostcardDesigns(
  props.campaign?.designs,
)
</script>

<style></style>
